import { Tabs } from 'antd'
import React, { FunctionComponent } from 'react'

import { BusinessContactTable } from '../components/BusinessContactTable/BusinessContactTable'
import { BuybackTable } from '../components/BuybackTable/BuybackTable'
import { CreatePriceEstimateButton as _CreateNewButton } from '../components/CreatePriceEstimateButton/CreatePriceEstimateButton'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PageLayoutTabContainer } from '../components/PageLayoutTabContainer/PageLayoutTabContainer'
import { PropertyDetailDrawer } from '../components/PropertyDetailDrawer/PropertyDetailDrawer'
import { TabLabel } from '../components/TabLabel/TabLabel'
import { ZustavateDataTable } from '../components/ZustavateDataTable/ZustavateDataTable'
import { tabsProps } from '../utils/tabsHelpers'
import { useTabKeyState } from '../utils/useTabKeyState'
import LoanCalculator from './LoanCalculator'

const labelClassName = 'text-base text-center block w-40'

enum BuybackTabType {
  INTERNAL = 'interni',
  ZUSTAVATE = 'zustavate',
  LOAN = 'urokove',
  BUSINESS_CONTACT = 'business-contact',
}

const tabItems = [
  {
    key: BuybackTabType.INTERNAL,
    label: <TabLabel title="Interní kalkulace" className={labelClassName} />,
    children: (
      <PageLayoutTabContainer className="flex-nowrap">
        <BuybackTable />
      </PageLayoutTabContainer>
    ),
  },
  {
    key: BuybackTabType.ZUSTAVATE,
    label: <TabLabel title="Z webu" className={labelClassName} />,
    children: (
      <PageLayoutTabContainer className="flex-nowrap">
        <ZustavateDataTable />
      </PageLayoutTabContainer>
    ),
  },
  {
    key: BuybackTabType.LOAN,
    label: <TabLabel title="Úrokové" className={labelClassName} />,
    children: (
      <PageLayoutTabContainer className="flex-nowrap">
        <LoanCalculator />
      </PageLayoutTabContainer>
    ),
  },
  {
    key: BuybackTabType.BUSINESS_CONTACT,
    label: <TabLabel title="Firemní kontakty" className={labelClassName} />,
    children: (
      <PageLayoutTabContainer className="flex-nowrap">
        <BusinessContactTable />
      </PageLayoutTabContainer>
    ),
  },
]

export const Buyback: FunctionComponent = () => {
  const [activeTabKey, setActiveTabKey] = useTabKeyState<BuybackTabType>(
    BuybackTabType.INTERNAL
  )

  return (
    <>
      <PageLayout
        title="Kalkulace nabídek"
        isContainer
        extra={
          activeTabKey === BuybackTabType.INTERNAL ? (
            <_CreateNewButton
              buttonText="Vytvořit novou kalkulaci"
              description="kalkulaci nabídky"
            />
          ) : null
        }
      >
        <Tabs
          {...tabsProps}
          items={tabItems}
          activeKey={activeTabKey}
          onTabClick={setActiveTabKey}
        />
      </PageLayout>
      <PropertyDetailDrawer />
    </>
  )
}

export default Buyback
